module.exports = __webpack_public_path__ + "static/media/wxpay.ea8de1f0.png";